import { createAsyncThunk } from '@reduxjs/toolkit';

import { getHttpClient } from '../../../http/httpClientManager';

type FreshnessResponse = { actuals_through: string | null };

// How far the tenant's synced actuals reach. Every dashboard needs it to stop
// offering days the warehouse cannot answer for; it is fetched once per boot
// because switching tenant is a hard reload.
export const fetchFreshness = createAsyncThunk<string | null, void>(
  'app/fetchFreshness',
  async () => {
    const res = await getHttpClient('api').get<FreshnessResponse>('/api/v1/meta/freshness');
    return res.data.actuals_through ?? null;
  },
);
